export default "__VITE_ASSET__D914eHxW__"